import * as Icons from "lucide-react";

export default function Icon({ name, className = "h-5 w-5", strokeWidth = 2 }) {
  const LucideIcon = Icons[name] || Icons.Circle;
  return <LucideIcon className={className} strokeWidth={strokeWidth} />;
}
